import React from 'react';
import QuarantineDataTab from 'js/components/elements/quarantineFiles/QuarantineDataTabContainer';
import { useDrawerContext } from 'new/components/drawer/useDrawerContext';

interface ErrorDataProps {
  resourceId: string;
  resourceType: string;
}

export const ErrorData = (props: ErrorDataProps) => {
  const { resourceId, resourceType } = props;
  const { drawerContentRef } = useDrawerContext();
  return (
    <QuarantineDataTab
      parentScrollRef={drawerContentRef}
      resourceType={resourceType}
      data={{ id: resourceId }}
    />
  );
};
